<template>
  <el-card>
    <el-row :gutter="5">
      <el-col :sm="24">
        <span>{{ title }}</span>
        <el-button style="float: right;" size="mini" icon="el-icon-delete" type="danger"
          @click.prevent="remove">Remover</el-button>
        <el-button style="float: right; margin-right: 5px" size="mini" v-if="file.processing === false" type="info"
          @click.prevent="download">Download</el-button>
        <span style="float: right; margin-right: 5px" v-else>Arquivo em processamento</span>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { UserNotificationService } from "@/services/users/user.notification.services";
export default {
  data() {
    return {
      active: [],
    };
  },
  props: {
    file: {},
    index: null,
    options: {
      default: true
    },
  },
  computed: {
    title() {
      if (this.file && this.file.data) {
        return this.file.data.name;
      }
      return '';
    }
  },
  methods: {
    download() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      UserNotificationService.download(vm.file.id)
        .then((response) => {
          let filename = 'arquivo.csv';
          if (this.file && this.file.data) {
            filename = this.file.data.filename;
          }
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());

    },
    remove() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      UserNotificationService.delete(vm.file.id)
        .then((response) => {
          vm.$emit('delete', vm.index);
          this.$message({
            type: "success",
            duration: 5000,
            message: "Arquivo removido com sucesso!",
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style scoped>
.text {
  font-size: 14px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
  min-height: 160px;
  margin: 25px 0;
}
</style>